import { MatDialog } from "@angular/material/dialog";
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChildren, } from "@angular/core";
import { DataSource } from "@angular/cdk/collections";
import { WarningComponent } from "src/app/shared/components/warning/warning.component";
import { BehaviorSubject, Observable, Subject, } from "rxjs";
import { NotificationService } from "src/app/core/services/notification.service";
import { CommonService } from "src/app/core/services/common.service";
import { NotifierService } from "angular-notifier";
import { BaseComponent } from "src/app/shared/components/base/base.component";

import { animate, state, style, transition, trigger, } from "@angular/animations";

import { map, startWith } from "rxjs/operators";
import { Message } from "src/app/core/class/message";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl, FormGroup } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { MasterDataTypeService } from "src/app/core/services/master-data-type.service";
import { GeneralCategory } from "src/app/shared/models/general-category.model";
import { ErrorCode } from "src/app/core/constants/error-code";

@Component({
  selector: "app-list-category",
  templateUrl: "./list-category.component.html",
  styleUrls: ["./list-category.component.scss"],
  animations: [
    trigger("detailExpand", [
      state(
        "void",
        style({ height: "0px", minHeight: "0", visibility: "hidden" })
      ),
      state("*", style({ height: "*", visibility: "visible" })),
      transition("void <=> *", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")),
    ]),
  ],
})
export class ListCategoryComponent
  extends BaseComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren("focusInput") focusInput;

  searchCategoryForm: FormGroup;
  listDataSource: GeneralCategoryDataSource;

  displayedColumns = ["stt", "name", "parent", "description", "action"];

  category = {
    name: "",
    codeOrValue: "",
    parentId: null,
    page: 0,
    size: 10,
  };

  paginate = {
    currentPage: 0,
    pageSize: 10,
    totalRow: 0,
    totalPage: 0,
    totalPageArray: [],
    no: [],
  };

  listParents: {
    parentId: string;
    parentName: string;
  }[] = [];

  listParentsFilter: Observable<any>;

  searchParentCtrl: FormControl = new FormControl(null);
  loadingSearch: boolean = false;
  _onDestroy = new Subject<void>();

  constructor(
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private router: Router,
    public toast: ToastrService,
    public route: ActivatedRoute,
    private notificationService: NotificationService,
    private masterDataTypeService: MasterDataTypeService
  ) {
    super(commonService, message);
    this.notifier = notifier;
    this.route.queryParams.subscribe((queryparams) => {
      this.category = {
        name: queryparams.name ? queryparams.name : null,
        codeOrValue: queryparams.codeOrValue ? queryparams.codeOrValue : null,
        parentId: queryparams.parentId ? queryparams.parentId : null,
        page: queryparams.page ? queryparams.page : 0,
        size: queryparams.size ? queryparams.size : 10,
      };
    });
  }

  ngOnInit() {
    this.searchCategoryForm = new FormGroup({
      nameContains: new FormControl(this.category.name),
      codeOrValueContains: new FormControl(this.category.codeOrValue),
      parentContains: new FormControl(this.category.parentId),
    });
    // if (this.commonService.getIsLockedEnterprise()) {
    //   this.displayedColumns = this.displayedColumns
    //     .filter(cd => (cd !== 'action' && cd !== 'status'))
    //     .map(cd => cd);
    // }
    this.listDataSource = new GeneralCategoryDataSource();
    this.loadData(this.category);
    window.scrollTo(0, 0);
    this.notificationService.subscribeErrorService();
    this.getListParent();
    this.initFormControlSearch();
  }

  ngAfterViewInit() {
    setTimeout((_) => this.focusInput.first.nativeElement.focus());
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    // this.unsubscribeErrorService();
    this.notificationService.subscribeErrorService();
  }

  loadData(request: any) {
    this.masterDataTypeService.getCategory(request).subscribe((res) => {
      if (!res || !res.data) {
        return;
      }
      this.listDataSource.setData(res.data.content);
      this.paginate = {
        currentPage: res.data.pageable.page,
        pageSize: res.data.pageable.size,
        totalRow: res.data.total,
        totalPage: Math.ceil(res.data.total / res.data.pageable.size),
        totalPageArray: this.commonService.counter(
          Math.ceil(res.data.total / res.data.pageable.size),
          1
        ),
        no: this.commonService.counter(
          res.data.pageable.size,
          res.data.pageable.page * res.data.pageable.size + 1
        ),
      };
    });
  }
  /**
   * Filter data with condition
   */
  onClickBtnFilter() {
    const controls = this.searchCategoryForm.controls;

    this.category.name = controls.nameContains.value
      ? controls.nameContains.value
      : null;
    this.category.codeOrValue = controls.codeOrValueContains.value
      ? controls.codeOrValueContains.value
      : null;
    this.category.parentId = controls.parentContains.value
      ? controls.parentContains.value
      : null;
    this.category.page = 0;
    this.category.size = 10;

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        ...this.category,
      },
      queryParamsHandling: "merge",
      replaceUrl: true,
      skipLocationChange: false,
    });
  }

  clearData(field: string) {
    this.searchCategoryForm.get(field).patchValue(null);
  }

  onPageChange(page: number = 0, pageSize: number = 10) {
    this.paginate = {
      ...this.paginate,
      currentPage: page,
      pageSize,
    };
    this.category.page = this.paginate.currentPage;
    this.category.size = this.paginate.pageSize;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        ...this.category,
      },
      queryParamsHandling: "merge",
      replaceUrl: true,
      skipLocationChange: false,
    });
  }

  editCategory(id: string) {
    const link = `/home-enterprise/general-category/update/${id}`;

    this.masterDataTypeService.getCategoryById(id).subscribe(res => {
      if (!res || res.code === ErrorCode.MasterDataTypeNotFound) {
        this.toast.error(
          this.message.getMessage("messages.delete_category_not_found_error")
        );
        this.router.navigateByUrl('/home-enterprise/general-category');
      } else {
        this.router.navigateByUrl(link);
      }
    })
  }

  async deleteCategory(element) {
    const dataDialog = this.commonService.format(
      this.message.getMessage("messages.confirm_delete_category"),
      element.name
    );
    const warnDialog = this.dialog.open(WarningComponent, {
      width: "40%",
      data: dataDialog,
    });
    warnDialog.afterClosed().subscribe(async (res) => {
      if (res) {
        let checkParent = false;
        const request = {
          name: "",
          page: 0,
          size: 1000,
        };
        let masterDataTypeParents = await this.masterDataTypeService.getParent(request).toPromise();
        if (masterDataTypeParents && masterDataTypeParents.data && masterDataTypeParents.data.content) {
          masterDataTypeParents.data.content.forEach(parent => {
            if (parent.id === element.id) {
              this.toast.error(
                this.message.getMessage("messages.delete_category_parent_error")
              );
              checkParent = true;
              return;
            }
          })
        }
        if (!checkParent) {
          this.masterDataTypeService
            .deleteCategory(element.id)
            .subscribe((res) => {
              if (!res) {
                this.toast.error(
                  this.message.getMessage("messages.delete_category_error")
                );
                return;
              }
              if (res.code === ErrorCode.MasterDataTypeNotFound) {
                this.toast.error(
                  this.message.getMessage("messages.delete_category_not_found_error")
                );
                this.router.navigateByUrl('/home-enterprise/general-category');
                return;
              }
              if (res.code === ErrorCode.MasterDataTypeDocumentTemplateBlock) {
                this.toast.error(
                  this.message.getMessage("messages.delete_category_config_error")
                );
                return;
              }
              this.toast.success(
                this.message.getMessage("messages.delete_category_success")
              );
              if (this.paginate.totalRow === 1) {
                this.router.navigate(["/home-enterprise/general-category"]);
              } else {
                if (
                  this.paginate.totalRow % this.paginate.pageSize === 1 &&
                  this.paginate.currentPage === this.paginate.totalPage - 1
                ) {
                  this.category.size = this.paginate.pageSize;
                  this.category.page = this.paginate.currentPage
                    ? this.paginate.currentPage - 1
                    : 0;
                }
                this.getListParent();
                this.loadData(this.category);
              }
            });
        }
      }
    });
  }

  onClickCreateCategory() {
    this.router.navigateByUrl("/home-enterprise/general-category/create");
  }

  initFormControlSearch() {
    this.listParentsFilter = this.searchParentCtrl.valueChanges.pipe(
      startWith(""),
      map((value) => {
        if (!value) {
          return this.listParents;
        }
        return this.listParents.filter((st) => {
          const optionLabel = `${st.parentName}`;
          return optionLabel.toLowerCase().includes(value.trim().toLowerCase());
        });
      })
    );
  }

  getListParent() {
    this.listParents = [];
    const request = {
      name: "",
      page: 0,
      size: 1000,
    };
    this.masterDataTypeService.getParent(request).subscribe((res) => {
      if (res.data && res.data.content.length) {
        res.data.content.forEach((item) => {
          let temp = {
            parentId: "",
            parentName: "",
          };
          if (item.name) {
            temp.parentName = item.name;
          }

          if (item.id) {
            temp.parentId = item.id;
          }
          if (temp.parentId && temp.parentName) {
            this.listParents.push(temp);
          }
        });

        this.listParents = this.listParents.sort((a, b) => {
          return a.parentName.localeCompare(b.parentName);
        });

        const isExistsMasterdata = res.data.content.find(value => {
          return this.searchCategoryForm.controls.parentContains.value && this.searchCategoryForm.controls.parentContains.value === value.id
        })
        if (this.searchCategoryForm.controls.parentContains.value && !isExistsMasterdata) {
          this.clearData('parentContains');
        }
      } else {
        if (this.searchCategoryForm.controls.parentContains.value) {
          this.clearData('parentContains');
        }
      }
      this.searchParentCtrl.patchValue("");
    });
  }

  focusOut(field: string) {
    const value = this.searchCategoryForm.get(field).value
      ? this.searchCategoryForm.get(field).value.trim()
      : null;
    this.searchCategoryForm.get(field).patchValue(value);
  }

  displayTooltip(data, index, className) {
    const elmsSpan = document.getElementsByClassName(className);
    const elmsCell = document.getElementsByClassName("cell");

    if (elmsSpan.item(index).scrollWidth > elmsCell.item(index).scrollWidth) {
      return data;
    } else {
      return null;
    }
  }

  displayTooltipForDes(data, index, className) {
    const elmsSpan = document.getElementsByClassName(className);
    const elmsCellDes = document.getElementsByClassName("cellDes");

    if (elmsSpan.item(index).scrollWidth > elmsCellDes.item(index).scrollWidth) {
      return data;
    } else {
      return null;
    }
  }
}

export class GeneralCategoryDataSource extends DataSource<GeneralCategory> {
  /** Stream of data that is provided to the table. */
  private data = new BehaviorSubject<GeneralCategory[]>([]);
  private loading = new BehaviorSubject<boolean>(false);

  public loading$ = this.loading.asObservable();

  constructor() {
    super();
  }

  // indicate is loading
  startLoadData() {
    this.loading.next(true);
  }

  setData(data: GeneralCategory[]) {
    /* this.data = new BehaviorSubject<DocumentType[]>(data); */
    this.data.next(data);
    this.loading.complete();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<GeneralCategory[]> {
    /* return this.data; */
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
    this.loading.complete();
  }
}
